/** D12 (décision d'Olivier du 29.10.2026) : versions du contrat Module Spec, comme ModuleSpecVersions côté serveur. La version
 * courante est 1.11 ; 1.10 et les versions antérieures restent lues. Une capacité « 1.10 et suivantes » se teste par specAtLeast,
 * jamais par une égalité littérale ; toute nouvelle version porte CURRENT_SPEC_VERSION. */
export const CURRENT_SPEC_VERSION = '1.11' as const;
export const SUPPORTED_SPEC_VERSIONS = ['1.0', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8', '1.9', '1.10', '1.11'] as const;
export type SupportedSpecVersion = typeof SUPPORTED_SPEC_VERSIONS[number];
const minor = (version: unknown): number => { const match = typeof version === 'string' ? /^1\.(\d{1,3})$/.exec(version) : null; return match ? Number(match[1]) : -1; };
/** Vrai quand `version` vaut au moins `minimum` (1.11 ≥ 1.10 ≥ 1.9…). */
export function specAtLeast(version: unknown, minimum: SupportedSpecVersion): boolean {
  return minor(version) >= minor(minimum);
}
/** D12 : capacités du gabarit apparues en 1.11 ; un nœud qui en porte une fait passer la spécification à la version courante. */
export function templateNeedsCurrentSpec(node: unknown): boolean {
  return JSON.stringify(node ?? null).includes('"dateStyle":"long"');
}
export function supportedSpecVersion(version: unknown): version is SupportedSpecVersion {
  return (SUPPORTED_SPEC_VERSIONS as readonly string[]).includes(String(version));
}
